import axios from 'axios';
import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from '../authConfig';

export interface RuleCondition {
  id: number;
  ruleId: number;
  sourceField: string;
  operator: string;
  inputValue: string;
}

export interface OutputRule {
  id: number;
  profileId: number;
  outputField: string;
  ruleName: string;
  outputValue: string;
  priority: number;
  logicalOperator: string;
  conditions: RuleCondition[];
}

export interface DocumentProfile {
  id: number;
  profileName: string;
  documentIntelligenceModelId: string;
  rules: OutputRule[];
}

export interface CreateProfileDto {
  profileName: string;
  documentIntelligenceModelId: string;
}



export interface CreateRuleDto {

  profileId: number;

  outputField: string;

  ruleName:string;

  outputValue: string;

  priority: number;

  logicalOperator: string;

  conditions: {

    sourceField: string;

    operator: string;

    inputValue: string;

  }[];

}



export interface CreateConditionDto {

  ruleId: number;

  sourceField: string;

  operator: string;

  inputValue: string;

}



const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/profiles`; 



const getAuthConfig = async (instance: IPublicClientApplication, account: any) => {

    const response = await instance.acquireTokenSilent({

        ...apiRequest,

        account: account

    });

    return {

        headers: {

            Authorization: `Bearer ${response.accessToken}`,

            'Content-Type': 'application/json'

        }

    };

};



export const getAllProfiles = async (

  instance: IPublicClientApplication, 

  account: any

): Promise<DocumentProfile[]> => {

    const config = await getAuthConfig(instance, account);

    const response = await axios.get<DocumentProfile[]>(API_URL, config);

    return response.data;

};



export const createProfile = async (

  instance: IPublicClientApplication, 

  account: any, 

  newProfile: CreateProfileDto

): Promise<{ id: number }> => {

    const config = await getAuthConfig(instance, account);

    const response = await axios.post<{ id: number }>(API_URL, newProfile, config);

    return response.data;

};



export const deleteProfile = async (

  instance: IPublicClientApplication, 

  account: any, 

  profileId: number

): Promise<void> => {

    const config = await getAuthConfig(instance, account);

    await axios.delete(`${API_URL}/${profileId}`, config);

};



export const createRule = async (

  instance: IPublicClientApplication, 

  account: any, 

  newRule: CreateRuleDto

): Promise<{ id: number }> => {

    const config = await getAuthConfig(instance, account);

    const response = await axios.post<{ id: number }>(`${API_URL}/rules`, newRule, config);

    return response.data;

};



export const deleteRule = async (

  instance: IPublicClientApplication, 

  account: any, 

  ruleId: number

): Promise<void> => {

    const config = await getAuthConfig(instance, account);

    await axios.delete(`${API_URL}/rules/${ruleId}`, config);

};



export const addConditionToRule = async (

  instance: IPublicClientApplication,

  account: any,

  newCondition: CreateConditionDto

): Promise<{ id: number }> => {

  const config = await getAuthConfig(instance, account);

  const response = await axios.post<{id: number}>(`${API_URL}/rules/conditions`, newCondition, config);

  return response.data;

}



export const deleteCondition = async (

  instance: IPublicClientApplication, 

  account: any, 

  conditionId: number

): Promise<void> => {

    const config = await getAuthConfig(instance, account);

    await axios.delete(`${API_URL}/rules/conditions/${conditionId}`, config);

};
